<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto">
            <div class="input-card-form">
              <label class="form-control text-left">Calle y Número</label>
              <input type="text" v-model="allresponses.address"  class="form-control text-left" placeholder="Ej: Calle de Fuencarral 13" @change="ValidarRespuesta" @keypress="ValidarRespuesta" />
            </div>
          </div>
        </div>
    </div>
    <div class="row mx-lg-auto" style="margin-top:10px;">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto">
            <div class="input-card-form">
              <label class="form-control text-left">Portal / Escalera / Piso / Puerta</label>
              <input type="text" v-model="allresponses.otherDetailsAddress"  class="form-control text-left" placeholder="Ej: Portal 4, Piso 6F" @change="ValidarRespuesta" @keypress="ValidarRespuesta" />
            </div>
          </div>
        </div>
    </div>
    <div class="row mx-lg-auto" style="margin-top:10px;">
         <div class="col-md-6 mx-lg-auto ">
            <div class="row">
                <div class="col-md-6">
                <div class="input-card">
                    <div class="input-card-form">
                    <label class="form-control text-left">Población</label>
                    <input type="text" v-model="allresponses.poblation"  class="form-control text-left" placeholder="Ej: Madrid" @change="ValidarRespuesta" @keypress="ValidarRespuesta" />
                    </div>
                </div>
                </div>
                <div class="col-md-6">
                <div class="input-card">
                    <div class="input-card-form">
                    <label class="form-control text-left">Código Postal</label>
                    <input type="text" v-model="allresponses.cp"  class="form-control text-left" placeholder="Ej: 28046" @change="ValidarRespuesta" @keypress="ValidarRespuesta" />
                    </div>
                </div>
                </div>
            </div>

        </div>

    </div>
    <div class="row mx-lg-auto" style="margin-top:10px;">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto">
            <div class="input-card-form">
              <label class="form-control text-left">Provincia</label>
              <input type="text" v-model="allresponses.state"  disabled="true" class="form-control text-left" placeholder="Primero rellene el Código Postal" @change="ValidarRespuesta" />
            </div>
          </div>
        </div>
    </div>
</template>

<script>

import ValidarCP from './CodigoPostal/ValidarCodigoPostal'

export default {
  name: 'DireccionPostal',
  props: {

      response: String,
      FormularioTag: String,
      idQuestion: Number,
      allresponses: Object

  },
  data: function(){

      return {

          calle: null,
          resto: null,
          poblacion: null,
          cp: null,
          provincia: null
      }

  },

  methods: {

      ValidarRespuesta : function(){


        if (this.allresponses.cp != null)
        {

            let Provincia = ValidarCP.validarCP(this.allresponses.cp);
            
            if (Provincia != false)
            {

                this.allresponses.state = Provincia;

            }

        }


        if (this.allresponses.cp != null && this.allresponses.state != null && this.allresponses.address != null  && this.allresponses.poblation != null )
        {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: true,
                response: this.allresponses.address+', '+this.allresponses.otherDetailsAddress+', '+this.allresponses.poblation+', '+this.allresponses.cp+', '+this.allresponses.state,
                allresponses: this.allresponses
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);    


        } else {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: false,
                response: null,
                allresponses: this.allresponses
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);          


        }

      }



  }
}
</script>

<style scoped>

    label {

        font-size:10pt;
        font-weight: bold;

    }


</style>